import { User } from "./User";

export const INITIAL_VALUES: User = {
	UserId: null,
	UserName: "",
	FirstName: "",
	LastName: "",
	AuthTypeId: 1,
	IsActive: true,
	LastLogin: null,
	DefaultAssetId: null,
	ProfilesId: [],
	Profiles: [],
	Permissions: [],
};
